import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faMobile } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import { findUsersUsingAgentIds } from '@functions/agent'

import useCampaign from '@hooks/useCampaign'
import useSelector from '@hooks/useSelector'

import type { CampaignModel } from '@models/types'

interface MediaSelectionToolsProps {
  campaign: CampaignModel,
  isMediaSelector: boolean,
}

const MediaSelectionTools = (props: MediaSelectionToolsProps) => {
  const { campaign, isMediaSelector } = props

  const campaignPayload = useCampaign(campaign)
  const {
    callbacks: {
      selectSMSRecipient,
      shareEmailLink,
    },
    campaign: {
      agent_ids: agentIds,
    },
  } = campaignPayload

  const { users } = useSelector(reduxState => reduxState.entities)

  const campaignAgentUsers = findUsersUsingAgentIds({ agentIds, users })
  const agentUsersWithMobileNumber = campaignAgentUsers.filter(user => !!user?.mobile_number)
  const agentUsersWithEmail = campaignAgentUsers.filter(user => !!user?.email)

  return (
    <Tools>
      {!isMediaSelector && (
        <>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faMobile} />}
            onClick={() => selectSMSRecipient({
              activityKey: 'media_selection.shared',
              endPoint: `campaigns/${campaign.id}/users`,
              linkAnchor: 'media-selection?mediaSelector=true',
              preSelectedUsers: agentUsersWithMobileNumber,
              completeSelection: false,
            })}
            size="medium"
          >
            Send for Selection (SMS)
          </Button>

          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faEnvelope} />}
            //@ts-expect-error
            marginTop="medium"
            onClick={() => shareEmailLink({
              endPoint: `campaigns/${campaign.id}/users`,
              linkAnchor: 'media-selection?mediaSelector=true',
              preSelectedUsers: agentUsersWithEmail,
              completeSelection: false,
            })}
            size="medium"
          >
            Send for Selection (Email)
          </Button>
        </>
      )}

      {isMediaSelector && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faEnvelope} />}
          onClick={() => shareEmailLink({
            endPoint: `campaigns/${campaign.id}/users`,
            linkAnchor: 'media-selection',
            preSelectedUsers: [],
            completeSelection: true,
          })}
          size="medium"
        >
          Complete Media Selection
        </Button>
      )}
    </Tools>
  )
}

export default MediaSelectionTools
